import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as actions from "../../actions";
import { useLocation } from "react-router-dom";
import * as Template from "../../templates";

export default () => {
  const moduleName = "brands";
  const location = useLocation()
  const appReducer = useSelector((state) => state.appReducer);
  const dispatch = useDispatch();
  const [rows, setRows] = useState([])
  const [totalPages, setTotalPages] = useState(0)

  const handleDelete = id => dispatch(actions.destroy(id, moduleName))

  useEffect(() => {
    dispatch(actions.list(moduleName, location.search));
  }, [appReducer.brands_destroy, location.search]);

  useEffect(() => {
    if (appReducer.brands_list != undefined) {
      setRows(appReducer.brands_list.data)
      setTotalPages(appReducer.brands_list.count)
    }
  }, [appReducer])


  const columns = [
    {
      name: 'نام',
      selector: row => row.name,
    },
    {
      name: 'نوع',
      selector: row => row.national == 'ir' ? 'داخلی' : 'خارجی',
    },
    ,
    {
      name: 'لوگو',
      selector: row => row.logo_medium_full ? <img className="w-24 mt-4" src={row.logo_medium_full} /> : "-"
    },
    {
      name: 'وضعیت',
      selector: row => <Template.State variant={row.state} />,
    },
    {
      name: 'تاریخ ایجاد',
      selector: row => row.created_at,
    },
    {
      name: 'عملیات',
      selector: row => <Template.TableButton handleDelete={() => handleDelete(row.id)} row={row} location={location} />,
    },
  ];

  return <Template.Table count={totalPages} columns={columns} data={rows} />;

};
